// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"ca0f83d8","513":"b8194613","703":"3b94fd28"}[chunkId] + ".chunk.js";
};